export default {"src":"/_next/static/media/personplus.7688cd87.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};